import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import getRotate from './getRotate';
import '../progress/index.css';
var Progress = (function (_super) {
    tslib_1.__extends(Progress, _super);
    function Progress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Progress.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, prefix = _b.prefix, percent = _b.percent, showInfo = _b.showInfo, status = _b.status, others = tslib_1.__rest(_b, ["className", "prefix", "percent", "showInfo", "status"]);
        var classes = cn(className, prefix + "-wrapper");
        var innerClass = cn(prefix + "-inner", (_a = {},
            _a[prefix + "-active"] = percent < 100 && percent > 5 && status !== 'exception',
            _a[prefix + "-exception"] = status === 'exception',
            _a[prefix + "-success"] = percent >= 100,
            _a));
        var width = percent + '%';
        var rest = 100 - percent + '%';
        var start = 3;
        var rotate = percent <= 50 ? getRotate(start, percent) : getRotate(start, 101 - percent);
        var xRotate = showInfo ? "rotateZ(" + (percent <= 50 ? start : -rotate) + "deg)" : '';
        var yRotate = showInfo ? "rotateZ(" + (percent <= 50 ? rotate : -start) + "deg)" : '';
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others),
            React.createElement("span", { className: innerClass, style: { width: width, transform: xRotate } }, showInfo && React.createElement("span", { className: "zhui-progress-tag" }, percent)),
            React.createElement("span", { className: "zhui-progress-outer", style: { width: rest, transform: yRotate } })));
    };
    Progress.defaultProps = {
        className: '',
        prefix: 'zhui-progress',
        showInfo: true,
        status: 'active',
        percent: 0,
    };
    return Progress;
}(React.Component));
export default Progress;
